// Payload mockado consolidando o formulário completo de contato.
// Estrutura compatível com o schema descrito em baseform.md, mas
// contendo apenas um formulário (`form_contact`). O frontend decide
// quais perguntas renderizar em cada etapa usando `contactFormSteps`.

export const queryPayload = {
  _id: '123456',
  formName: 'form_contact',
  formLabel: 'Atendimento Flash',
  createdAt: '2024-10-27T00:00:00.000Z',
  updatedAt: '2024-10-27T00:00:00.000Z',
  questions: [
    {
      _id: 'q_contact_cpf',
      questionName: 'cpf',
      questionLabel: 'CPF',
      questionType: 'input',
      options: [],
    },
    {
      _id: 'q_contact_role',
      questionName: 'role',
      questionLabel: 'Selecione o seu perfil',
      questionType: 'select',
      description: 'Selecione se você é colaborador ou administrador.',
      options: [
        {
          _id: 'opt_contact_role_employee',
          optionName: 'employee',
          optionLabel: 'Colaborador',
        },
        {
          _id: 'opt_contact_role_admin',
          optionName: 'admin',
          optionLabel: 'Administrador da empresa',
        },
      ],
    },
    {
      _id: 'q_contact_company_name',
      questionName: 'companyName',
      questionLabel: 'Nome da empresa que trabalha / fornece Flash',
      questionType: 'input',
      options: [],
    },
    {
      _id: 'q_contact_cnpj',
      questionName: 'cnpj',
      questionLabel: 'CNPJ da empresa que trabalha / fornece Flash',
      questionType: 'input',
      description:
        'Campo obrigatório apenas para administradores. Opcional para colaboradores.',
      options: [],
      dependency: {
        dependsOnQuestionName: 'role',
        allowedOptionNames: ['admin'],
      },
    },
    {
      _id: 'q_contact_full_name',
      questionName: 'fullName',
      questionLabel: 'Nome completo',
      questionType: 'input',
      options: [],
    },
    {
      _id: 'q_contact_phone',
      questionName: 'phone',
      questionLabel: 'Telefone para contato',
      questionType: 'input',
      description: 'Informe um telefone celular com DDD.',
      options: [],
    },
    {
      _id: 'q_contact_email_confirmation',
      questionName: 'emailConfirmation',
      questionLabel: 'Confirme seu e-mail',
      questionType: 'input',
      options: [],
    },
    {
      _id: 'q_contact_email',
      questionName: 'email',
      questionLabel: 'E-mail para contato',
      questionType: 'input',
      options: [],
    },
    {
      _id: 'q_contact_reason_bu',
      questionName: 'reasonBu',
      questionLabel: 'Sobre o que você deseja falar?',
      questionType: 'select',
      description: 'Escolha o produto Flash relacionado ao seu atendimento.',
      options: [
        {
          _id: 'opt_contact_reason_bu_benefits',
          optionName: 'reasonBuBenefits',
          optionLabel:
            'Benefícios (Cartão de Benefícios, Saldo, Extrato, Transações, Senha, 2a Via, Cartão Virtual, Login, outros)',
        },
        // !!! Não esta no excel
        // {
        //   _id: 'opt_contact_reason_bu_corporate_card',
        //   optionName: 'reasonBuCorporateCard',
        //   optionLabel:
        //     'Cartão Corporativo (Reclassificação, Prestação de Contas, Relatórios, Notas Fiscais, 2a Via, Cartão Virtual, etc...)',
        // },
        {
          _id: 'opt_contact_reason_bu_expense',
          optionName: 'reasonBuExpense',
          optionLabel:
            'Despesas (Prestação de contas, Despesas corporativas reembolsáveis, Cartão de Despesas Corporativas, Reclassificação)',
        },
        {
          _id: 'opt_contact_reason_bu_people',
          optionName: 'reasonBuPeople',
          optionLabel:
            'Gestão de Pessoas (Folha de ponto, Treinamentos, Performance, Organograma)',
        },
        {
          _id: 'opt_contact_reason_bu_travel',
          optionName: 'reasonBuTravel',
          optionLabel:
            'Viagens corporativas (Hospedagem, Passagem aérea, Cancelamento, Alteração de reserva)',
          dependency: {
            dependsOnQuestionName: 'role',
            allowedOptionNames: ['employee', 'admin'],
          },
        },
      ],
    },
    {
      _id: 'q_contact_reason_reason',
      questionName: 'reasonReason',
      questionLabel: 'Sobre qual assunto',
      questionType: 'select',
      description: 'Nos ajude a entender o motivo da sua solicitação.',
      dependency: {
        dependsOnQuestionName: 'role',
        allowedOptionNames: ['employee', 'admin'],
      },
      options: [
        {
          _id: 'opt_contact_reason_reason_login',
          optionName: 'reasonReasonLogin',
          optionLabel:
            'Ajuda com Login ou acesso ao App, Reset/alteração de senha, Alteração de dados pessoais',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuBenefits'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_saldo',
          optionName: 'reasonReasonSaldo',
          optionLabel:
            'Saldo ou disponibilização de Benefícios, 2a Via do Cartão, Extrato, Transação Negada, Contestação de compras, Outros',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuBenefits'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_despesas_login',
          optionName: 'reasonReasonDespesasLogin',
          optionLabel:
            'Ajuda com Login ou acesso ao App, Reset/alteração de senha, Alteração de dados pessoais',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuExpense'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_despesas_reembolso',
          optionName: 'reasonReasonDespesasReembolso',
          optionLabel:
            'Despesas Corporativas e Reembolso: Prestação de Contas, Aprovação, Relatórios, Notas Fiscais, Relatórios, Trajeto, Outros',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuExpense'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_corporativo',
          optionName: 'reasonReasonCorporativo',
          optionLabel:
            'Cartão Corporativo: reclassificação, saldo, extrato, 2a Via, Outros',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuExpense'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_pessoas_login',
          optionName: 'reasonReasonPessoasLogin',
          optionLabel:
            'Ajuda com Login ou acesso ao App, Reset/alteração de senha, Alteração de dados pessoais',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuPeople'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_pessoas_marcacao',
          optionName: 'reasonReasonPessoasMarcacao',
          optionLabel:
            'Marcação de ponto, Lançar atestado/eventos, Banco de horas, Espelho de ponto',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuPeople'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_pessoas_treinamento',
          optionName: 'reasonReasonPessoasTreinamento',
          optionLabel:
            'Ajuda/Dúvida com Módulos de Treinamento, Performance, Organograma, Outros',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuPeople'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_travel_login',
          optionName: 'reasonReasonTravelLogin',
          optionLabel:
            'Ajuda com Login ou acesso ao App, Reset/alteração de senha, Alteração de dados pessoais',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuTravel'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_travel_lodging',
          optionName: 'reasonReasonTravelLodging',
          optionLabel:
            'Hospedagem: Cotação de hospedagem, Reservar hospedagem, Problemas durante a hospedagem',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuTravel'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_travel_flight',
          optionName: 'reasonReasonTravelFlight',
          optionLabel:
            'Passagem aérea: Cotação de passagem, Reservar passagem, Remarcar passagem',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuTravel'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_travel_cancellation',
          optionName: 'reasonReasonTravelCancellation',
          optionLabel:
            'Cancelamento de reserva: Cancelar hospedagem, Cancelar aéreo',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuTravel'],
          },
        },
        {
          _id: 'opt_contact_reason_reason_travel_modification',
          optionName: 'reasonReasonTravelModification',
          optionLabel:
            'Alteração de reserva: Alterar data da hospedagem, Alterar data do voo',
          dependency: {
            dependsOnQuestionName: 'reasonBu',
            allowedOptionNames: ['reasonBuTravel'],
          },
        },
      ],
    },
    {
      _id: 'q_contact_reason_application',
      questionName: 'reasonApplication',
      questionLabel: 'Em qual aplicativo você precisa de ajuda?',
      questionType: 'radioButton',
      description: 'Selecione o aplicativo em que está tendo dificuldades.',
      options: [
        {
          _id: 'opt_contact_reason_application_flash',
          optionName: 'reasonApplicationFlash',
          optionLabel: 'Flash',
          dependency: {
            dependsOnQuestionName: 'reasonReason',
            allowedOptionNames: [
              'reasonReasonDespesasLogin',
              'reasonReasonPessoasLogin',
              'reasonReasonPessoasMarcacao',
            ],
          },
        },
        {
          _id: 'opt_contact_reason_application_flash_expense',
          optionName: 'reasonApplicationFlashExpense',
          optionLabel: 'Flash Expense',
          dependency: {
            dependsOnQuestionName: 'reasonReason',
            allowedOptionNames: ['reasonReasonDespesasLogin'],
          },
        },
        {
          _id: 'opt_contact_reason_application_folha_certa',
          optionName: 'reasonApplicationFolhaCerta',
          optionLabel: 'Folha Flash',
          dependency: {
            dependsOnQuestionName: 'reasonReason',
            allowedOptionNames: [
              'reasonReasonPessoasLogin',
              'reasonReasonPessoasMarcacao',
            ],
          },
        },
      ],
      dependency: {
        dependsOnQuestionName: 'reasonReason',
        allowedOptionNames: [
          'reasonReasonDespesasLogin',
          'reasonReasonPessoasLogin',
          'reasonReasonPessoasMarcacao',
        ],
      },
    },
    {
      _id: 'q_contact_travel_id_has_no_id',
      questionName: 'reasonHasNoTravelId',
      questionLabel: 'Não tenho o ID da viagem',
      questionType: 'checkbox',
      options: [
        {
          _id: 'opt_contact_travel_id_has_no_id_true',
          optionName: 'true',
          optionLabel: 'Não tenho o ID da viagem',
        },
      ],
      dependency: {
        dependsOnQuestionName: 'reasonReason',
        allowedOptionNames: [
          'reasonReasonTravelLodging',
          'reasonReasonTravelFlight',
          'reasonReasonTravelCancellation',
          'reasonReasonTravelModification',
        ],
      },
    },
    {
      _id: 'q_contact_travel_id',
      questionName: 'reasonTravelId',
      questionLabel: 'ID da viagem',
      questionType: 'input',
      description: 'Informe o ID da viagem relacionada à sua solicitação.',
      options: [],
      dependency: {
        dependsOnQuestionName: 'reasonReason',
        allowedOptionNames: [
          'reasonReasonTravelLodging',
          'reasonReasonTravelFlight',
          'reasonReasonTravelCancellation',
          'reasonReasonTravelModification',
        ],
      },
    },
    {
      _id: 'q_contact_message_body',
      questionName: 'messageBody',
      questionLabel: 'Mensagem',
      questionType: 'input',
      description:
        'Dê o máximo de informações possíveis para que o time consiga ajudar.',
      options: [],
      dependency: {
        dependsOnQuestionName: 'reasonBu',
        anyAnswer: true,
      },
    },
    {
      _id: 'q_contact_message_attachments',
      questionName: 'messageAttachments',
      questionLabel: 'Enviar anexos (opcional)',
      questionType: 'fileUpload',
      options: [],
      dependency: {
        dependsOnQuestionName: 'reasonBu',
        anyAnswer: true,
      },
    },
    {
      _id: 'q_contact_message_has_no_account',
      questionName: 'messageHasNoAccount',
      questionLabel: 'Ainda não recebi/ativei ou perdi meu cartão',
      questionType: 'checkbox',
      options: [
        {
          _id: 'opt_contact_message_has_no_account_true',
          optionName: 'true',
          optionLabel: 'Sim, ainda não recebi/ativei ou perdi meu cartão',
        },
        {
          _id: 'opt_contact_message_has_no_account_false',
          optionName: 'false',
          optionLabel: 'Não, já tenho o cartão',
        },
      ],
      dependency: {
        dependsOnQuestionName: 'role',
        allowedOptionNames: ['employee'],
      },
    },
    {
      _id: 'q_contact_message_qr_code',
      questionName: 'messageQrCode',
      questionLabel: 'Número do QR Code',
      questionType: 'input',
      description:
        'Informe os 8 dígitos do QR Code impresso no cartão para acelerar o atendimento.',
      options: [],
      dependency: {
        dependsOnQuestionName: 'messageHasNoAccount',
        allowedOptionNames: ['false'],
      },
    },
    {
      _id: 'q_contact_impersonation_consent',
      questionName: 'reasonImpersonationConsent',
      questionLabel:
        'Concordo em permitir que a equipe de suporte da Flash acesse temporariamente minha conta para ajudar na resolução de problemas.',
      questionType: 'checkbox',
      description:
        'Para saber mais sobre como utilizamos seus dados, [clique aqui](https://faq.flashapp.com.br/kb/guide/pt-BR/por-que-preciso-autorizar-o-suporte-a-acessar-temporariamente-minha-conta-OoX6PJPOWu/Steps/4880651).',
      options: [
        {
          _id: 'opt_contact_impersonation_consent_true',
          optionName: 'true',
          optionLabel:
            'Concordo em permitir que a equipe de suporte da Flash acesse temporariamente minha conta para ajudar na resolução de problemas.',
        },
      ],
      dependency: {
        dependsOnQuestionName: 'isTargetForImpersonation',
        allowedOptionNames: ['true'],
      },
    },
  ],
}

const adjustPayload = (payload: typeof queryPayload) => {
  const questionsDict = payload.questions.reduce(
    (acc, question) => {
      acc[question.questionName] = question
      return acc
    },
    {} as Record<string, (typeof payload.questions)[number]>,
  )

  return {
    ...payload,
    questions: questionsDict,
  }
}

export const formDataAdjusted = adjustPayload(queryPayload)

export type ContactReasonQuestion = {
  _id: string
  questionName: string
  questionLabel: string
  questionType: string
  options: readonly {
    _id: string
    optionName?: string
    optionLabel?: string
    dependency?: {
      dependsOnQuestionName: string
      allowedOptionNames?: readonly string[]
      anyAnswer?: boolean
    }
  }[]
  description?: string
  dependency?: {
    dependsOnQuestionName: string
    allowedOptionNames?: readonly string[]
    anyAnswer?: boolean
  }
}

// export const formOptionValueMap = {
//   opt_contact_role_employee: 'employee',
//   opt_contact_role_admin: 'admin',
//   opt_contact_reason_bu_benefits: 'benefits',
//   opt_contact_reason_bu_corporate_card: 'corporateCard',
//   opt_contact_reason_bu_expense: 'expense',
//   opt_contact_reason_bu_people: 'people',
//   opt_contact_reason_reason_compliment: 'compliment',
//   opt_contact_reason_reason_question: 'question',
//   opt_contact_reason_reason_request: 'request',
//   opt_contact_reason_reason_complaint: 'complaint',
//   opt_contact_reason_reason_suggestion: 'suggestion',
//   opt_contact_reason_application_flash: 'flash',
//   opt_contact_reason_application_flash_expense: 'flashExpense',
//   opt_contact_reason_application_folha_certa: 'folhaCerta',
// } as const

// export const contactFormSteps = {
//   identification: {
//     formId: 'form_contact_identification',
//     label: 'Identificação do contato',
//     questionIds: [
//       'q_contact_cpf',
//       'q_contact_role',
//       'q_contact_company_name',
//       'q_contact_cnpj',
//       'q_contact_full_name',
//       'q_contact_phone',
//       'q_contact_email_confirmation',
//       'q_contact_email',
//     ],
//   },
//   reason: {
//     formId: 'form_contact_reason',
//     label: 'Motivo de contato',
//     questionIds: [
//       'q_contact_reason_bu',
//       'q_contact_reason_reason',
//       'q_contact_reason_application',
//     ],
//   },
//   message: {
//     formId: 'form_contact_message',
//     label: 'Mensagem de contato',
//     questionIds: [
//       'q_contact_message_body',
//       'q_contact_message_has_no_account',
//       'q_contact_message_qr_code',
//     ],
//   },
// }
